import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";

import { LoginComponent } from "./login/login.component";
import { UserRoutingModule } from "./user-routing.module";
import { UserRepository } from "./user.repository";
import { UserService } from "./user.service";

import { NgxPermissionsModule } from "ngx-permissions";
import { GroupRepository } from "./group/group.repository";
import { UiModule } from "../ui/ui.module";
import { NotifyModule } from "../notify/notify.module";
import { SharedModule } from "../shared/shared.module";
import { UserListComponent } from "./user-list/user-list.component";
import { UserFormComponent } from "./user-form/user-form.component";
import { UserFormPasswordComponent } from "./user-form-password/user-form-password.component";
import { UserFormEmailComponent } from "./user-form-email/user-form-email.component";
import { TeamRepository } from "../team/team.repository";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { SelectModule } from "primeng/select";
import { TooltipModule } from "primeng/tooltip";
import { TabsModule } from "primeng/tabs";
import { CheckboxModule } from "primeng/checkbox";
import { MultiSelectModule } from "primeng/multiselect";
import { FileUploadModule } from "primeng/fileupload";
import { PasswordModule } from "primeng/password";
import { InputTextModule } from "primeng/inputtext";
import { CompanyRepository } from "app/company/company.repository";

@NgModule({
  imports: [
    FormsModule,
    PasswordModule,
    NgxPermissionsModule.forChild(),
    DialogModule,
    ButtonModule,
    SelectModule,
    CommonModule,
    UiModule,
    NotifyModule,
    UserRoutingModule,
    TooltipModule,
    TabsModule,
    ReactiveFormsModule,
    InputTextModule,
    SharedModule,
    CheckboxModule,
    MultiSelectModule,
    FileUploadModule,
    LoginComponent,
    UserListComponent,
    UserFormComponent,
    UserFormPasswordComponent,
    UserFormEmailComponent,
  ],
  providers: [
    UserRepository,
    UserService,
    TeamRepository,
    GroupRepository,
    CompanyRepository,
  ],
})
export class UserModule {}
